import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { GigStepPropertyWithValue, MilestoneFile, MilestoneStep } from '../../../../types/collaborations/CollaborationTypes'
import { sanitizeURLs } from '../../../../utils/helpers';
import DOMPurify from 'dompurify';
import { useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../redux-stores/store';
import { useDispatch } from 'react-redux';
import { fetchAddressThunk } from '../../../../redux-stores/slices/addressSlice';
import { SavedAddress } from '../../../../types/address';
import docIcon from "../../../../components/icons/Icon-doc.svg"
import moment, { MomentInput } from 'moment';
import InstagramCaption from '../../../InstagramCaption';
import playIcon from "../../../../assets/images/play-icon.png"
import { fetchBasicPostThunk, fetchBasicSocialPostThunk } from '../../../../redux-stores/slices/postsSlice';
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper/modules"
import 'swiper/css';
import 'swiper/css/navigation';
import { setSelectedPost, setSelectedSocialPost } from '../../../../redux-stores/slices/layoutSlice';
import { useParams } from 'react-router-dom';

interface PropertiesPreviewProps {
    step: MilestoneStep,
    files: MilestoneFile[],
    setSelectedMedia: (media: any) => void,
    deliverables: any
}

const PropertiesPreview: React.FC<PropertiesPreviewProps> = ({ step, files, setSelectedMedia, deliverables }) => {

    const dispatch: AppDispatch = useDispatch();
    const {campaignId} = useParams();

    const addressBook = useSelector((state: RootState) => state.addressBook.items);

    const basicPosts = useSelector((state: RootState) => state.posts.basic_social_posts);
    const collaborationData = useSelector((state: RootState) => state.collaborationDetails.collaborations[campaignId!]?.collaborationData);
    const collaboration = collaborationData?.collaboration ?? null;
    const socialAccount = collaboration?.social_account ?? null;

    const properties = useMemo(() => {
        const keys = Object.keys((deliverables ?? {}));
        const _properties: GigStepPropertyWithValue[] = [];
        for (let key of keys) {
            const property = step.gig_step.properties.find((pr) => (pr.key === key || pr.key === 'post' && key === 'social_post'));
            if (property) _properties.push({ ...property, value: (deliverables ?? {})[key] });
        }

        return _properties.sort((a, b) => a.sort_order - b.sort_order);
    }, [step, deliverables])

    useEffect(() => {
        const addressProperties = properties.filter((property) => property.type === 'address');
        for (let addressProperty of addressProperties) {
            if (addressProperty.value && typeof addressProperty.value === 'string')
                dispatch(fetchAddressThunk({ addressUUID: addressProperty.value }))
        }
    }, [properties])

    useEffect(() => {
        if (['post_selection', 'reel_selection', 'story_selection', 'video_selection'].includes(step.gig_step.slug)) {
            if (Array.isArray(deliverables.social_post)) {
                for (let postId of deliverables.social_post) {
                    dispatch(fetchBasicSocialPostThunk(postId));
                }
            }
        }
    }, [step, deliverables])

    const getCombinedAddress = (address: SavedAddress | undefined | null) => {

        if (address) {
            const combinedAddress = `${address.premise ? address.premise + ',' : ''} ${address.sublocality ? address.sublocality + ',' : ''} ${address.city ? address.city + ',' : ''} ${address.region ? address.region + ',' : ''} ${address.pincode}`;
            return combinedAddress;
        }

        return "";
    }

    const getFilePreview = useCallback((fileId: string) => {
        const file = files.find((file) => file.step === step.gig_step.slug && file.uuid === fileId);
        return file
    }, [files, step])

    return (
        <div>
            {
                properties.map((property, i) => {
                    if (property.key === 'approval') return null;

                    if (property.type === 'address') {
                        return (
                            <div key={i} className='property-preview'>
                                <div className="content-wrapper">
                                    {getCombinedAddress(addressBook[property.value as string]?.address)}
                                </div>
                            </div>
                        )
                    }

                    if (property.type === 'post') {

                        return (
                            <div key={i} className='property-preview'>
                                <div className="content-wrapper">
                                    {
                                        deliverables?.social_post?.length > 0 &&
                                        <Swiper
                                            slidesPerView={'auto'}
                                            spaceBetween={18}
                                            navigation={true}
                                            modules={[Navigation]}
                                            freeMode={true}
                                            className="mySwiper">
                                            {
                                                deliverables.social_post.map((postId: string, i: number) => {
                                                    const post = basicPosts[postId]?.post;
                                                    console.log('asdfasdfasd', post)
                                                    if(!post) return null;

                                                    return (
                                                        <SwiperSlide className="milestone-view-ig-media w-auto" key={i}>
                                                            <div onClick={() => dispatch(setSelectedSocialPost({socialPostId: postId, socialAccountId: socialAccount?.uuid}))} className="position-relative post-preview-thumbnail bgc-content bg-media" style={{ backgroundImage: `url(${post?.thumbnail_url})` }}>
                                                            </div>
                                                        </SwiperSlide>

                                                    )
                                                })
                                            }
                                        </Swiper>
                                    }
                                </div>
                            </div>
                        )
                    }

                    if (['file', 'large_file'].includes(property.type) && property.value && typeof property.value === 'string') {
                        return (
                            <div key={i} className='property-preview'>
                                {
                                    getFilePreview(property.value) &&
                                    <>
                                        {
                                            getFilePreview(property.value)?.type === 'image' &&
                                            <div onClick={() => setSelectedMedia(getFilePreview(property.value as string))} className="cursor-pointer bg-media gig-image" style={{ backgroundImage: `url(${getFilePreview(property.value)?.url})` }}></div>
                                        }
                                        {
                                            getFilePreview(property.value)?.type === 'video' &&
                                            <div className='position-relative gig-image'>
                                                <video onClick={() => setSelectedMedia(getFilePreview(property.value as string))} className='gig-image rounded-2 video-preview' src={getFilePreview(property.value)?.url}></video>
                                                <img src={playIcon} className='video-play-icon' />
                                            </div>
                                        }
                                        {
                                            getFilePreview(property.value)?.type === 'other' &&
                                            <a href={getFilePreview(property.value)?.url} target='_blank' className='d-block gig-image bg-media' style={{ backgroundImage: `url(${docIcon})` }}></a>
                                        }
                                    </>
                                }
                            </div>
                        )
                    }

                    if (property.type === 'datetime') {
                        return (
                            <div key={i} className='property-preview'>
                                {
                                    properties.length > 1 &&
                                    <label htmlFor="property-preview-value" className="property-preview-label">{property.label}</label>
                                }
                                <div className="content-wrapper">
                                    {moment(property.value as MomentInput).format('MMMM Do YYYY, h:mm A')}
                                </div>
                            </div>
                        )
                    }

                    if (property.type === 'caption') {
                        return (
                            <div key={i} className='property-preview'>
                                {
                                    properties.length > 1 &&
                                    <label htmlFor="property-preview-value" className="property-preview-label">{property.label}</label>
                                }
                                <InstagramCaption fontSize='12px' text={String(property.value)} />
                            </div>
                        )
                    }

                    return (
                        <div key={i} className='property-preview'>
                            {
                                properties.length > 1 &&
                                <label htmlFor="property-preview-value" className="property-preview-label">{property.label}</label>
                            }
                            {
                                <div
                                    className={`content-wrapper`}
                                >
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(
                                                sanitizeURLs(
                                                    typeof property.value === 'string'
                                                        ? property.value
                                                        : typeof property.value === 'object' && property.value !== null && 'text' in property.value
                                                            ? (property.value as any).text ?? ''
                                                            : ''
                                                )
                                            ),
                                        }}
                                    />
                                </div>
                            }
                        </div>
                    )
                })
            }
        </div>
    )
}

export default PropertiesPreview